import { isMockMode, post, simulateDelay } from "../api";

export const addToUsers = (data) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Licences/AddToUsers`, data, {
		successMessage: "Licenses successfully assigned",
	});
};
